<template>
    <BaseModal :title="title" @close="handleModal" :visible="true" size="small" customClass="">
        <div class="assetssment__cover__box tab-content tbh__popup__block transcribe__popup__wrap">
            <div class="transcribe__features__group">
                <div class="add__note__test__box response__group__wrapper"
                    :style="{ paddingInline: 0, boxShadow: 'none' }">
                    <div class="cover__group__box" v-for="item in data" :key="item.id">
                        <div class="addnote__box">
                            <label>{{ item.question }}</label>
                            <template v-if="consonantStates(item)?.length">
                                <div class="tbh__labels__group">
                                    <template v-for="(c, index) in consonantStates(item)" :key="index">
                                        <template v-if="c.value === '-'"> - </template>
                                        <template v-else-if="c.value === ' '"> &nbsp; </template>
                                        <template v-else>
                                            <span class="label"
                                                :class="[getClassForState(c.state), { 'disabled-label': true }]"
                                                :title="noResponse ? 'Disabled when No Response is checked' : ''">
                                                {{ c.value }}
                                            </span>
                                        </template>
                                    </template>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="sepline__divider rlms-mt-5"></div>
        <template #footer>
            <div class="pp-footer rlms-flex rlms-justify-center" style="padding: 0;">
                <RouterLink :to="`/organizations/${organizationId}/learners/${learnerId}/assessments/${assessmentId}`"
                    class="rlms-btn rlms-btn-primary" id="save-org-btn" style="flex: none;">View</RouterLink>
            </div>
        </template>
    </BaseModal>
</template>

<script setup>
import { ref } from 'vue';
import BaseModal from '../BaseModal.vue';

// eslint-disable-next-line
const emit = defineEmits(['close', 'saved']);
defineProps({
    organizationId: Number,
    learnerId: Number,
    assessmentId: Number,
    data: Object,
});

const title = `Details`;

const showModal = ref(true);

const handleModal = (action = 'close') => {
    showModal.value = false;
    emit(action);
};

const consonantStates = (newItem) => {
    // Parse consonants
    let parsedConsonants = [];
    try {
        if (newItem?.consonant) {
            parsedConsonants = JSON.parse(newItem?.consonant?.replace(/'/g, '"')) || [];
        } else {
            parsedConsonants = newItem?.question.split('-');
        }
    } catch {
        parsedConsonants = [];
    }

    let parsedConsonantScore = [];
    parsedConsonantScore = typeof newItem?.consonant_score === 'string'
        ? JSON.parse(newItem.consonant_score)
        : newItem?.consonant_score || [];


    parsedConsonants = parsedConsonants.map((value, index) => {
        // Unscored slots stay neutral; only a recorded 0 shows as red.
        const score = parsedConsonantScore?.[index];
        let state = 'default';
        if (score == 1 || score === true) state = 'green';
        else if (score == 0 || score === false) state = 'red';
        return { id: index, value, state };
    });

    return parsedConsonants;
}

const getClassForState = (state) => {
    if (state === 'green') return 'green';
    if (state === 'red') return 'red';
    return 'purple';
};
</script>
